import { DateTime } from 'luxon';

export function removeTimezone(date: Date): Date {
	const dt = DateTime.fromJSDate(date).toUTC();
	return dt.toJSDate();
}

export function convertUTCToTimezoneDate(utcString: string): Date {
	const utcDateTime = DateTime.fromSQL(utcString, { zone: 'utc' });
	const zonedDateTime = utcDateTime.setZone('Europe/Helsinki');
	return zonedDateTime.toJSDate();
}

export function formatUtcToTimezone(utcString: string, timezone: string) {
	return DateTime.fromFormat(utcString, 'yyyy-MM-dd HH:mm', { zone: 'utc' })
		.setZone(timezone)
		.toFormat('dd.MM.yyyy - HH:mm');
}

export function dbTimeToJsDate(date: string) {
	const formats = [
		'yyyy-MM-dd HH:mm:ss',
		'yyyy-MM-dd HH:mm:ss.SSS',
		'yyyy-MM-dd HH:mm',
		'yyyy-MM-dd HH-mm',
	];

	let dt: DateTime | null = null;
	for (const format of formats) {
		dt = DateTime.fromFormat(date, format, { zone: 'utc' });
		if (dt.isValid) break;
	}

	if (!dt || !dt.isValid) {
		throw new Error(`Invalid date: ${date}`);
	}

	return dt.toJSDate();
}

export function dbTimeToUserTime(
	date: string | Date,
	timeZone: string,
	options?: {
		includeSeconds: boolean;
	},
): string {
	const formats = [
		'yyyy-MM-dd HH:mm:ss',
		'yyyy-MM-dd HH:mm:ss.SSS',
		'yyyy-MM-dd HH-mm',
	];

	let dt: DateTime | null = null;
	for (const format of formats) {
		dt = DateTime.fromFormat(date as string, format, { zone: 'utc' });
		if (dt.isValid) break;
	}

	if (!dt || !dt.isValid) {
		throw new Error(`Invalid date: ${date}`);
	}

	const zoned = dt.setZone(timeZone);
	const formatStr = options?.includeSeconds
		? 'dd.MM.yyyy HH:mm:ss'
		: 'dd.MM.yyyy HH:mm';

	return zoned.toFormat(formatStr);
}

export function formatDateUTC(date: Date): string {
	const pad = (n: number) => n.toString().padStart(2, '0');

	const format = (d: Date, useUTC: boolean) => {
		const year = useUTC ? d.getUTCFullYear() : d.getFullYear();
		const month = useUTC ? d.getUTCMonth() + 1 : d.getMonth() + 1;
		const day = useUTC ? d.getUTCDate() : d.getDate();
		const hours = useUTC ? d.getUTCHours() : d.getHours();
		const minutes = useUTC ? d.getUTCMinutes() : d.getMinutes();

		return `${year}-${pad(month)}-${pad(day)} ${pad(hours)}:${pad(
			minutes,
		)}`;
	};

	return format(date, true);
}
